module.exports = __webpack_public_path__ + "header-profile-skin-2.8307c45ca34d4af71912.png";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/patterns/header-profile-skin-2.png
// module id = 909
// module chunks = 2